<odx-modal-header>
  <odx-area-header i18n="@@modal.referenceMeasure.modal.header">Bitte bestätigen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <p i18n="@@modal.referenceMeasure.modal.text">
    Wird der Wert des Referenzmaßes geändert, verändern sich auch die Werte der skalierten Objekte auf dem Grundrissplan.
    Fortfahren?
  </p>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" (click)="onDismiss()" i18n="@@global.dismiss">Abbrechen</button>
  <button odxButton variant="primary" (click)="onConfirm()" i18n="@@modal.generalConfirmation.button.confirm">OK</button>
</odx-modal-footer>
